<template>
  <section
    class="mabc-promo"
    data-ui="mabc-promo"
  >
    <step-card-set
      :member-moment="true"
      :heading="heading"
      :subheading="subheading"
      :steps="steps"
      data-ui="mabc-card-steps"
    />
    <h3
      class="mabc-promo__secondary-heading"
      v-html="ctaHeading"
    />
    <add-membership-to-cart
      :is-added-to-cart="membershipInCart"
      :cta-text="ctaText"
      cta-full-width="@xs"
      class="mabc-promo__atc"
      :secondary-button-style="true"
      data-analytics-config="exclude"
      @click="handleAddMembership"
      @error="handleError"
      @success="$emit('success')"
    />
  </section>
</template>

<script setup>
import AddMembershipToCart from '@rei/add-membership-to-cart';
import { metricsLinkAddToCart } from '../../../utils/analytics';
import StepCardSet from '../../../common/components/step-cards/StepCardSet.vue';

const props = defineProps({
  ctaHeading: {
    type: String,
    required: true,
  },
  ctaText: {
    type: String,
    required: true,
  },
  heading: {
    type: String,
    required: true,
  },
  steps: {
    type: Array,
    required: true,
  },
  subheading: {
    type: String,
    required: true,
  },
});

const $emit = defineEmits(['error', 'success']);

/* c8 ignore start */
const handleAddMembership = () => {
  metricsLinkAddToCart(`membership:MABC_Add a one-time $${props.membershipCost} membership to cart`);
};
const handleError = (arg) => $emit('error', arg);
/* c8 ignore end */
</script>

<style lang="scss">
.mabc-promo {
  margin: $cdr-space-two-x 0;
  @include cdr-sm-mq-down {
    .step-card-set__track{
      margin-bottom: $cdr-space-one-x;
    }
  }
}

.mabc-promo__secondary-heading {
  @include cdr-text-heading-serif-400;
  padding: 0 $cdr-space-one-x;
  text-align: center;
  color: $cdr-color-text-brand;
  margin-bottom: $cdr-space-one-x;
  margin-top: 0;
  @include cdr-md-mq-up {
    @include cdr-text-heading-serif-600;
  }
}

.mabc-promo__atc {
  text-align: center;
  padding: 0 $cdr-space-one-x;
  margin: 0 auto $cdr-space-one-and-a-half-x;
  display: flex;
  justify-content: center;
  @include cdr-md-mq-up {
    margin-bottom: $cdr-space-two-x;
  }

  .add-membership__button {
    width: 100%;
    max-width: 340px;
    justify-content: center;
  }
}

.mabc-promo {
  .step-card-set {
    margin: 0 auto;
  }

  .step-card-set__heading {
    @include cdr-text-heading-serif-600;
    color: $cdr-color-text-brand;
    max-width: 625px;
    margin: 0 auto $cdr-space-half-x;

    .fancy-heading {
      @include cdr-md-mq-up {
        position: relative;
          &::after {
          background-image: url('/assets/membership/member-moment/underline/borderline.svg');
          background-repeat: no-repeat;
          position: absolute;
          bottom: -10px;
          left: 0px;
          content: "";
          width: 100%;
          height: 14px;
          background-size: cover;
        }
      }
    }
    @include cdr-md-mq-up {
      @include cdr-text-heading-serif-800;
      margin-bottom: $cdr-space-one-x;
    }
  }

  .step-card-set__subheading {
    @include cdr-text-body-300;
    margin-bottom: $cdr-space-one-x;
  }

  .step-card {
    max-width: initial;
  }
}
</style>
